module.exports = __webpack_public_path__ + "static/media/bottom_banner_7_2.90a93792.png";